import { render, staticRenderFns } from "./RunnitBoardRow.vue?vue&type=template&id=c39964d8&scoped=true"
import script from "./RunnitBoardRow.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardRow.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBoardRow.vue?vue&type=style&index=0&id=c39964d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39964d8",
  null
  
)

export default component.exports